module.exports = __webpack_public_path__ + "img/guidanceBg.d28969db.png";